<template>
  <el-container>
    <el-main>
      <div style="margin-bottom: 16px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="item_font">智能助手配置</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar">
        <div class="toolbar-left">
          <el-button type="primary" size="small" @click="openEdit()">新增配置</el-button>
          <el-button size="small" type="primary" plain @click="openGlobalPrompt"
            >编辑公共 Prompt</el-button
          >
          <el-button size="small" @click="loadList">刷新</el-button>
        </div>
        <div class="toolbar-right" v-if="checkedList.length">
          <span class="toolbar-right__label">当前启用</span>
          <el-tag
            v-for="item in checkedList"
            :key="item.id"
            size="small"
            type="success"
          >
            {{ item.modelName }}
          </el-tag>
        </div>
      </div>

      <div class="shared-prompt">
        <div class="shared-prompt__head">
          <span class="shared-prompt__title">公共 Prompt（所有模型共用）</span>
          <el-button type="text" size="small" @click="openGlobalPrompt">编辑</el-button>
        </div>
        <div class="shared-prompt__body" v-if="sharedPrompt">{{ sharedPrompt }}</div>
        <div class="shared-prompt__empty" v-else>暂未配置，点击「编辑公共 Prompt」进行设置</div>
      </div>

      <div class="model-panel" v-loading="loading">
        <div class="model-panel__head">
          <span>模型列表</span>
          <em>{{ tableData.length }} 个</em>
        </div>
        <div v-if="!tableData.length" class="model-panel__empty">暂无模型配置</div>
        <div
          v-for="row in tableData"
          :key="row.id"
          class="model-row"
        >
          <div class="model-row__name" :title="row.modelName">{{ row.modelName }}</div>
          <div class="model-row__actions">
            <el-switch
              :value="Number(row.checked) === 1"
              :disabled="switchingId === row.id"
              @change="(val) => onCheckedChange(row, val)"
            />
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="danger-text" @click="onDelete(row)"
              >删除</el-button
            >
          </div>
        </div>
      </div>

      <!-- 新增 / 编辑：不支持单独编辑 Prompt -->
      <el-dialog
        :title="form.id ? '编辑智能助手配置' : '新增智能助手配置'"
        :visible.sync="editVisible"
        width="520px"
        :close-on-click-modal="false"
        @closed="resetForm"
      >
        <el-form ref="editForm" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="模型名称" prop="modelName">
            <el-input v-model.trim="form.modelName" maxlength="100" placeholder="请输入模型名称" />
          </el-form-item>
          <el-form-item label="模型版本" prop="modelVersion">
            <el-input
              v-model.trim="form.modelVersion"
              maxlength="100"
              placeholder="请输入模型版本"
            />
          </el-form-item>
          <el-form-item label="启用" prop="checked">
            <el-switch
              v-model="form.checked"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="停用"
            />
          </el-form-item>
          <el-alert
            title="Prompt 由所有模型共用，请通过「编辑公共 Prompt」统一修改"
            type="info"
            :closable="false"
            show-icon
          />
        </el-form>
        <span slot="footer">
          <el-button @click="editVisible = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
        </span>
      </el-dialog>

      <!-- 公共 Prompt -->
      <el-dialog
        title="编辑公共 Prompt"
        :visible.sync="globalVisible"
        width="720px"
        :close-on-click-modal="false"
      >
        <el-alert
          title="所有模型共用同一份 Prompt，保存后将同步到全部模型"
          type="warning"
          :closable="false"
          show-icon
          style="margin-bottom: 12px"
        />
        <el-input
          v-model="globalPrompt"
          type="textarea"
          :rows="14"
          placeholder="请输入公共 Prompt"
        />
        <span slot="footer">
          <el-button @click="globalVisible = false">取消</el-button>
          <el-button type="primary" :loading="globalSaving" @click="submitGlobalPrompt"
            >保存</el-button
          >
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
const API = {
  list: "/manager/intelligentAssistantConfig/list",
  checkedList: "/manager/intelligentAssistantConfig/getCheckedList",
  save: "/manager/intelligentAssistantConfig/save",
  delete: "/manager/intelligentAssistantConfig/delete",
  setChecked: "/manager/intelligentAssistantConfig/setChecked",
  updateGlobalPrompt: "/manager/intelligentAssistantConfig/updateGlobalPrompt",
};

export default {
  name: "IntelligentAssistant",
  data() {
    return {
      loading: false,
      saving: false,
      globalSaving: false,
      switchingId: "",
      tableData: [],
      checkedList: [],
      editVisible: false,
      globalVisible: false,
      globalPrompt: "",
      form: {
        id: "",
        modelName: "",
        modelVersion: "",
        checked: 0,
        priority: 0,
      },
      rules: {
        modelName: [{ required: true, message: "请输入模型名称", trigger: "blur" }],
      },
    };
  },
  computed: {
    // 所有模型共用同一 Prompt，取列表中已有值展示
    sharedPrompt() {
      const hit = (this.tableData || []).find(
        (item) => item && item.promptTemplate && String(item.promptTemplate).trim()
      );
      return hit ? hit.promptTemplate : "";
    },
  },
  created() {
    this.loadAll();
  },
  methods: {
    isOk(res) {
      return res && String(res.resultCode) === "10000";
    },
    async loadAll() {
      await Promise.all([this.loadList(), this.loadCheckedList()]);
    },
    async loadList() {
      this.loading = true;
      try {
        const res = await this.util.postRequest({
          url: API.list,
          method: "POST",
        });
        if (this.isOk(res)) {
          this.tableData = Array.isArray(res.data) ? res.data : [];
        } else {
          this.$message.error((res && res.desc) || "获取配置列表失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("获取配置列表失败");
      } finally {
        this.loading = false;
      }
    },
    async loadCheckedList() {
      try {
        const res = await this.util.postRequest({
          url: API.checkedList,
          method: "POST",
        });
        if (this.isOk(res)) {
          this.checkedList = Array.isArray(res.data) ? res.data : [];
        }
      } catch (e) {
        console.error(e);
      }
    },
    resetForm() {
      this.form = {
        id: "",
        modelName: "",
        modelVersion: "",
        checked: 0,
        priority: 0,
      };
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
    },
    openEdit(row) {
      if (row) {
        this.form = {
          id: row.id || "",
          modelName: row.modelName || "",
          modelVersion: row.modelVersion || "",
          checked: Number(row.checked) === 1 ? 1 : 0,
          priority: Number(row.priority) || 0,
        };
      } else {
        this.resetForm();
      }
      this.editVisible = true;
    },
    submitForm() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const payload = {
            id: this.form.id || undefined,
            modelName: this.form.modelName,
            modelVersion: this.form.modelVersion,
            checked: Number(this.form.checked) === 1 ? 1 : 0,
            priority: Number(this.form.priority) || 0,
          };
          // 新增时带上公共 Prompt；编辑时不改 Prompt，避免单模型覆盖
          if (!this.form.id) {
            payload.promptTemplate = this.sharedPrompt || "";
          }
          const res = await this.util.postRequest({
            url: API.save,
            method: "POST",
            data: payload,
          });
          if (this.isOk(res)) {
            this.$message.success(this.form.id ? "更新成功" : "新增成功");
            this.editVisible = false;
            await this.loadAll();
          } else {
            this.$message.error((res && res.desc) || "保存失败");
          }
        } catch (e) {
          console.error(e);
          this.$message.error("保存失败");
        } finally {
          this.saving = false;
        }
      });
    },
    async onCheckedChange(row, enabled) {
      const checked = enabled ? 1 : 0;
      this.switchingId = row.id;
      try {
        const res = await this.util.postRequest({
          url: `${API.setChecked}?id=${encodeURIComponent(row.id)}&checked=${checked}`,
          method: "POST",
        });
        if (this.isOk(res)) {
          this.$message.success(checked === 1 ? "已启用" : "已停用");
          row.checked = checked;
          await this.loadCheckedList();
        } else {
          this.$message.error((res && res.desc) || "更新启用状态失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("更新启用状态失败");
      } finally {
        this.switchingId = "";
      }
    },
    onDelete(row) {
      this.$confirm(`确定删除模型「${row.modelName || row.id}」吗？`, "提示", {
        type: "warning",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      })
        .then(async () => {
          try {
            const res = await this.util.postRequest({
              url: `${API.delete}?id=${encodeURIComponent(row.id)}`,
              method: "POST",
            });
            if (this.isOk(res)) {
              this.$message.success("删除成功");
              await this.loadAll();
            } else {
              this.$message.error((res && res.desc) || "删除失败");
            }
          } catch (e) {
            console.error(e);
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },
    openGlobalPrompt() {
      this.globalPrompt = this.sharedPrompt || "";
      this.globalVisible = true;
    },
    async submitGlobalPrompt() {
      if (!this.globalPrompt || !String(this.globalPrompt).trim()) {
        this.$message.warning("请输入 Prompt 内容");
        return;
      }
      this.globalSaving = true;
      try {
        const res = await this.util.postRequest({
          url: API.updateGlobalPrompt,
          method: "POST",
          data: {
            promptTemplate: this.globalPrompt,
          },
        });
        if (this.isOk(res)) {
          this.$message.success("公共 Prompt 已更新");
          this.globalVisible = false;
          await this.loadAll();
        } else {
          this.$message.error((res && res.desc) || "更新失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("更新失败");
      } finally {
        this.globalSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-bottom: 14px;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.toolbar-right__label {
  @include change_size($font_size_normal);
  color: #909399;
}

.shared-prompt {
  margin-bottom: 14px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e5eaf3;
  border-radius: 6px;
}

.shared-prompt__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.shared-prompt__title {
  @include change_size($font_size_normal);
  font-weight: 600;
  color: #303133;
}

.shared-prompt__body {
  @include change_size($font_size_normal);
  max-height: 140px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
  color: #606266;
}

.shared-prompt__empty {
  @include change_size($font_size_normal);
  color: #c0c4cc;
}

.model-panel {
  border: 1px solid #e5eaf3;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.model-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f5f7fa;
  border-bottom: 1px solid #e5eaf3;
  @include change_size($font_size_normal);
  font-weight: 600;
  color: #303133;

  em {
    font-style: normal;
    font-weight: 400;
    color: #909399;
  }
}

.model-panel__empty {
  padding: 28px 14px;
  text-align: center;
  color: #c0c4cc;
  @include change_size($font_size_normal);
}

.model-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border-bottom: 1px solid #eef2f7;
}

.model-row:last-child {
  border-bottom: none;
}

.model-row__name {
  flex: 1;
  min-width: 0;
  @include change_size($font_size_normal);
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.model-row__actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: 14px;
}

.danger-text {
  color: #f56c6c !important;
}

.item_font {
  @include change_size($font_size_normal);
}
</style>
